import CopyField, { ButtonPlacement } from './CopyField';

export default CopyField;
export {
  ButtonPlacement,
};
